import { ref } from 'vue'
import { Url } from '@loca/mfe-vue3'
import { LayoutEventHub } from './LayoutUtils'

export default function useLayout() {
  // 左侧菜单是否折叠
  const isAsideCollapsed = ref(false)

  // 是否全屏
  const isFullscreen = ref(false)

  // -------------- methods
  const _initUrlParams = () => {
    const fullscreen = Url.getUrlSearch('fullscreen')
    if (fullscreen === 'true') isFullscreen.value = true
  }

  const handleCollapseStatusChange = (isCollapse: boolean) => {
    isAsideCollapsed.value = isCollapse
    // LayoutEventHub.syncCollapseStatusChange(isCollapse)
  }

  // -------------- init
  _initUrlParams()

  LayoutEventHub.isFullscreen = isFullscreen.value
  LayoutEventHub.onFullscreenChange((fullscreen: boolean) => {
    if (typeof fullscreen === 'boolean') {
      isFullscreen.value = fullscreen
    }
  })

  return {
    isFullscreen,
    isAsideCollapsed,
    handleCollapseStatusChange
  }
}
